import {spinnerClose, spinnerOpen} from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import axios from 'axios';
import _ from 'lodash';
import { PAGE_NAME, CONTRACT_SUBMIT_API, APPLICATION_STATUS } from '../../../../config/DEConstants';
import { SubmissionError} from 'redux-form';
import { setServerData } from '../../../../../framework/store/ServerData/ServerDataActions';
import { redirectFlowAction } from '../../../../../framework/store/RedirectFlow/RedirectFlowActions';
import { buildCapeTxnRunner } from '../../../../../framework/App/CapeTransaction';
import {NETWORK, REDIRECT_SUFFIX} from '../../../../../framework/App/AppConstants';
import {push} from 'connected-react-router';
import setUrl from '../../../../../framework/App/SetUrl';
const runDeEsignCapeTxn = buildCapeTxnRunner('de_esign');

export const handleRedirect = (response) => {
    if (_.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

export const submitContractApi = (data, localePrefix, intl) => (dispatch, getState) => {
    const state = getState();
    const { serverData = {} } = state;
    const { _csrf = '' } = serverData;
    // Todo: add action
    dispatch(spinnerOpen());

    return runDeEsignCapeTxn(() => {
        if (data.agreeToReadContract) {
            data.agreeToReadContract = 'acceptedCreditAgreement';
        }

        return axios
            .request({
                url: CONTRACT_SUBMIT_API,
                method: 'post',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            })
            .then(response => {
                if (!_.isEmpty(_.get(response, 'data.validation.errors'))) {
                    dispatch(spinnerClose());
                    capeLog && capeLog(`decisionApi:de:response: server validation error: ${JSON.stringify(response.data.validation.errors)}`);
                    const validationError = {
                        agreeToReadContract: {
                            msg: intl.formatMessage({id: `${localePrefix}.agreeContractError`}),
                            className: 'hasError'
                        }
                    };
                    return Promise.reject(new SubmissionError(validationError, state));
                } else if (_.get(response, 'data.applicationStatus') === APPLICATION_STATUS.APPROVED) {
                    dispatch(redirectFlowAction(REDIRECT_SUFFIX.RETURN_REDIRECT));
                } else {
                    dispatch(setServerData({ decisionModel: response.data }));
                    dispatch(push(PAGE_NAME.DECISION_PAGE));
                    dispatch(spinnerClose());
                }
            })
            .catch(error => {
                if (error instanceof SubmissionError) {
                    return Promise.reject(error);
                }
                capeLog && capeLog('response:error, DE_Member_TermsPageFormActions,' + (error && error.message));
                if (handleRedirect(error && error.response)) {
                    return;
                }

                if (_.get(error, 'response.data.err', false)) {
                    dispatch(setServerData({errorModel: _.get(error, 'response.data', {})}));
                    dispatch(push(PAGE_NAME.ERROR_PAGE));
                    dispatch(spinnerClose());
                } else {
                    // should never be here
                    capeLog && capeLog('response:error: unexpected error response for Contract Submit API');
                    setUrl(window, PAGE_NAME.ERROR_PAGE);
                }
            });
    });
};
